/*
 * @Author: chendz7
 * @Date: 2019-03-02 10:46:34
 */
export default {
    tagsView: {
        refresh: 'Refresh',
        closeOthers: 'Close others',
        closeAll: 'Close All',
        close: 'Close'
    },
    route: {
        index: 'Index',
        tableSort: 'table Sort',
        batchOperation: 'Batch Operation',
        editableTable: 'Editable Table',
        menuShrink: 'Menu Shrink',
        importAndExport: 'Import And Export',
        import: 'Import',
        export: 'Export',
        progress: 'Progress',
        dictionary: 'Dictionary',
        mPanel: 'Formal Panel',
        mPanel1: 'Formal Panel',
        mPanel2: 'Formal Panel 2',
        mPanel3: 'Formal Panel 3',
        notFound: '404',
        columns: 'Columns',
        filters: 'Filters',
        oss: 'OSS Demo',
        report: 'Report'
    },
    home: {

    },
    developer: {
        message: 'hello，developer！'
    }
};
